import { useState } from "react";
import { Icon } from "swing-components";

import { translate } from "~utils";

import { Toast } from "../Toast";

type CopyProps = {
  value?: string;
};

// Renders an icon button that copies the given value to the clipboard when clicked
// and shows a toast notification. If no value is provided, the component will not
// render anything.
export function Copy(props: CopyProps) {
  const { value } = props;
  const [showToast, setShowToast] = useState(false);

  const handleCopy = async () => {
    try {
      if (navigator.clipboard?.writeText && value) {
        await navigator.clipboard.writeText(value);
        setShowToast(true);
      }
    } catch {
      // Clipboard access denied; leave UI unchanged.
    }
  };

  if (!value) {
    return null;
  }

  return (
    <>
      <button type="button" onClick={handleCopy} aria-label="Copy">
        <Icon name="ContentCopy" color="var(--swing-slate600)" />
      </button>
      <Toast
        isVisible={showToast}
        type="positive"
        text={translate("LABEL_COPIED")}
        timeoutMs={1000}
        onDismiss={() => setShowToast(false)}
      />
    </>
  );
}
